import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import '../styles/LoginPage.css';

export default function ResetPassword() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [done, setDone] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirm) {
            setError('Die Passwörter stimmen nicht überein.');
            return;
        }
        if (password.length < 8) {
            setError('Das Passwort muss mindestens 8 Zeichen lang sein.');
            return;
        }
        setLoading(true);
        setError('');
        try {
            await api.post('/auth/reset-password', { token, password });
            setDone(true);
            setTimeout(() => navigate('/login'), 3000);
        } catch (err) {
            const detail = err?.response?.data?.detail;
            setError(detail || 'Der Link ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen an.');
        } finally {
            setLoading(false);
        }
    };

    if (!token) {
        return (
            <div className="login-container">
                <p style={{ color: 'var(--color-text-secondary)', fontSize: 14 }}>
                    Ungültiger Link. <Link to="/forgot-password" style={{ color: 'var(--color-primary)', fontWeight: 600, textDecoration: 'none' }}>Neuen Link anfordern</Link>
                </p>
            </div>
        );
    }

    return (
        <div className="login-container">
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none', marginBottom: 24 }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--color-primary)', display: 'inline-block' }} />
                <span style={{ fontWeight: 700, fontSize: 18, color: 'var(--color-text)' }}>Scalewisp</span>
            </Link>

            <h2 style={{ margin: '0 0 4px', fontSize: 22, fontWeight: 800, letterSpacing: '-0.01em' }}>Neues Passwort setzen</h2>
            <p style={{ margin: '0 0 24px', color: 'var(--color-text-secondary)', fontSize: 14 }}>
                Wählen Sie ein sicheres Passwort mit mindestens 8 Zeichen.
            </p>

            {done ? (
                <div style={{ padding: '14px 16px', background: 'rgba(34,197,94,0.1)', border: '1px solid rgba(34,197,94,0.25)', borderRadius: 8, fontSize: 14, color: 'var(--color-text)' }}>
                    Passwort erfolgreich geändert. Sie werden zur Anmeldung weitergeleitet…
                </div>
            ) : (
                <form onSubmit={handleSubmit} className="login-form">
                    <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: 'var(--color-text)' }}>
                        Neues Passwort
                    </label>
                    <input
                        type="password"
                        placeholder="Mindestens 8 Zeichen"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        required
                        className="login-input"
                    />
                    <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, marginTop: 12, color: 'var(--color-text)' }}>
                        Passwort bestätigen
                    </label>
                    <input
                        type="password"
                        placeholder="Passwort wiederholen"
                        value={confirm}
                        onChange={e => setConfirm(e.target.value)}
                        required
                        className="login-input"
                    />
                    <button
                        className="button"
                        type="submit"
                        disabled={loading || !password || !confirm}
                        style={{ background: 'var(--color-primary)', color: '#fff', padding: '10px', fontWeight: 600, fontSize: 15, borderRadius: 8 }}
                    >
                        {loading ? 'Wird gespeichert…' : 'Passwort speichern'}
                    </button>
                    {error && <p className="login-error">{error}</p>}
                </form>
            )}

            <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--color-text-secondary)' }}>
                <Link to="/login" style={{ color: 'var(--color-primary)', fontWeight: 600, textDecoration: 'none' }}>← Zurück zur Anmeldung</Link>
            </p>
        </div>
    );
}
